import React, { useContext, useEffect, useState } from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import { forwardRef } from 'react';
import { StyledProps, CSSProperties } from '@front10';
import Box from '../../elements/Box';
import Text from '../../elements/Text';
import Button from '../../elements/Button';
import Icon from '../../elements/Icon';

export interface Props {
  forwardedRef?: any;
  isChecked: boolean;
  showSideMessage?: boolean;
  className?: string;
  style?: CSSProperties;
  onChange: (a: boolean, b: any) => void;
  onClickSideMessage: (a: any) => void;
  item?: {
    label: string;
    iataCode: string;
  };
  optionStyles?: StyledProps<$TSFixMe>;
  labelStyles?: StyledProps<$TSFixMe>;
  containerStyles?: StyledProps<$TSFixMe>;
  sideMessageButtonStyles?: StyledProps<$TSFixMe>;
  isMobile: boolean;
  allItems?: any;
  showIcon?: boolean;
  setFocusOnItem?: boolean;
  icon?: string;
  iconStyles?: StyledProps<$TSFixMe>;
  enableFocus?: boolean;
  onKeyUp: $TSFixMe;
  onKeyDown?: $TSFixMe;
  dataTestId?: string;
}

function Checkbox(props: Props) {
  const { direction, theme, translate } = useContext(Context);
  const [classNameOptionStyles, styleOptionStyle] = useStyles(props.optionStyles, {
    direction,
    theme
  });
  const [showSideMessage, setShowSideMessage] = useState(
    props.isMobile !== undefined && props.isMobile && props.showSideMessage ? true : false
  );
  const [focusOn, setFocus] = React.useState(false);
  const Tag = props.enableFocus ? Box : Text;
  const handleFocus = () => {
    if (props.enableFocus) {
      setFocus(true);
    }
  };
  const inputRef = React.useRef<any>();
  useEffect(() => {
    if (inputRef && inputRef.current && props.setFocusOnItem) {
      inputRef.current.focus();
    }
  }, [props.setFocusOnItem]);

  return (
    <Box
      dataTestId={props.dataTestId}
      display="flex"
      alignItems="center"
      width="100"
      {...props.containerStyles}
      {...props.allItems}
      onMouseEnter={() => {
        if (props.showSideMessage) {
          setShowSideMessage(true);
        }
      }}
      onMouseLeave={() => {
        if (props.showSideMessage && !props.isMobile) {
          setShowSideMessage(false);
        }
      }}
    >
      <Tag
        className={`fr-input-checkbox-container ${classNameOptionStyles}`}
        style={styleOptionStyle}
      >
        <input
          ref={inputRef}
          className="fr-input-checkbox"
          type="checkbox"
          checked={props.isChecked}
          onFocus={handleFocus}
          onBlur={() => setFocus(false)}
          onChange={() => {
            props.onChange(props.isChecked, props.item);
            if (props.enableFocus) {
              inputRef.current?.focus();
            }
          }}
          aria-label={props.item?.label}
          onKeyUp={props.onKeyUp}
          onKeyDown={(e) => {
            if (props.onKeyDown) {
              props.onKeyDown(e);
            }
          }}
        />
        <Icon icon="checkbox" focusable={focusOn} viewBox="0 0 24 24" size={24} ariaHidden={true} />
        <Icon
          icon="checkbox-outline"
          focusable={focusOn}
          viewBox="0 0 24 24"
          size={24}
          ariaHidden={true}
        />
      </Tag>
      {props.showIcon && <Icon icon={props.icon} {...props.iconStyles} />}
      <Text textAlign="left" ariaHidden={true} {...props.labelStyles}>
        {props.item?.label}
      </Text>
      {showSideMessage && (
        <Button
          style={{
            background: 'transparent',
            border: 'none',
            padding: '0',
            marginRight: '10px',
            marginLeft: 'auto'
          }}
          {...props.sideMessageButtonStyles}
          onClick={() => props.onClickSideMessage(props.item)}
        >
          {translate('cmp-filter-side-message', 'Only')}
        </Button>
      )}
    </Box>
  );
}

Checkbox.defaultProps = {
  isChecked: false,
  isMobile: false,
  onChange: () => {},
  onClickSideMessage: () => {},
  showIcon: false,
  iconStyles: {},
  optionStyles: {},
  onKeyUp: () => {}
};

Checkbox.componentName = 'Checkbox';
export default forwardRef((props, ref) => <Checkbox forwardedRef={ref} {...props} />);
